// Options for calibration_table.operator_density_unit — the density_unit_type
// enum values from the database, with display labels. The panel keeps this
// unit synced across all three sensors, so every sensor page shares the same
// 'density_unit' setting.
export const DENSITY_UNIT_OPTIONS = [
  { value: 'lb_per_ft3', label: 'lb/ft³' },
  { value: 'lb_per_bushel', label: 'lb/bu' },
  { value: 'g_per_cm3', label: 'g/cm³' },
  { value: 'g_per_ml', label: 'g/mL' },
  { value: 'kg_per_l', label: 'kg/L' },
  { value: 'kg_per_m3', label: 'kg/m³' },
  { value: 'kg_per_hectoliter', label: 'kg/hL' },
];
